export const contractColumnData = {
  contractInfo: [
    { key: 'contractUniqueID', label: 'Contract Unique ID', width: null },
    { key: 'siteAssessmentID', label: 'Site Assessment ID', width: null },
    { key: 'pricingVersion', label: 'Pricing Version', width: null },
    { key: 'contractType', label: 'Contract Type', width: null },
    { key: 'purchaseType', label: 'Purchase Type', width: null },
    { key: 'notestoOffice', label: 'Internal Notes (WH Staff Only)', width: null },
    { key: 'notestoOperators', label: 'Notes for Grower / Owner', width: null },
  ],
  certificationInfo: [
    { key: 'forestSourcingArea', label: 'Forest Sourcing Area', width: null },
    { key: 'supplierType', label: 'Supplier Type', width: null },
    { key: 'validSelfDeclaration', label: 'Valid Self Declaration', width: null },
    { key: 'biomassSite', label: 'Biomass Site', width: null },
    { key: 'forestGrower', label: 'Forest Grower', width: null },
    { key: 'contractWith', label: 'Contract With', width: null },
    { key: 'harvestedBy', label: 'Harvested By', width: null },
    { key: 'tripartiteAgreement', label: 'Tripartite Agreement', width: null },
    { key: 'notes', label: 'Notes', width: null },
  ],
  coillteInfo: [
    { key: 'harvestingRate', label: 'Harvesting Rate', width: null },
    { key: 'harvestingMeasurementType', label: 'Harvesting Measurement Type', width: null },
    { key: 'harvestingAssest', label: 'Harvesting Asset', width: null },
    { key: 'forwardingRate', label: 'Forwarding Rate', width: null },
    { key: 'forwardingMeasurementType', label: 'Forwarding Measurement Type', width: null },
    { key: 'forwardingAssest', label: 'Forwarding Asset', width: null },
    { key: 'coillteRoadsideRate', label: 'Coillte Roadside Rate', width: null },
    { key: 'shortStakesPremium', label: 'Short Stakes Premium', width: null },
    { key: 'coillteRateConfirmedBy', label: 'Coillte Rate Confirmed By', width: null },
  ],
  timberPricingRates: [
    { key: 'product', label: 'Product', width: null },
    { key: 'destination', label: 'Destination', width: null },
    { key: 'haulage', label: 'Haulage Per Ton', width: null },
    { key: 'harvesting', label: 'Harvesting Cost Per Ton', width: null },
    { key: 'extraction', label: 'Extraction Cost Per Ton', width: null },
    { key: 'purchase', label: 'Purchase Price Per Ton', width: null },
  ],
  productDetails: [
    { key: 'productGroup', label: 'Product Group', width: null },
    { key: 'purchasePrice', label: 'Purchase Price', width: null },
    { key: 'productSource', label: 'Product Source', width: null },
    { key: 'estimatedQty', label: 'Estimated Qty', width: null },
    { key: 'destination', label: 'Destination', width: null },
  ],

  geolocations: [],

  contractQuestionnaire: [
    { key: 'firstThinnings', label: 'First Thinnings', width: null },
    { key: 'secondThinnings', label: 'Second Thinnings', width: null },
    { key: 'clearFell', label: 'Clear Fell', width: null },
    { key: 'treesLeftPerHectareIfDiff', label: 'Trees Left Per Hectare (If Diff)', width: null },
    { key: 'noteIfYouNeedDifferentQtys', label: 'Notes (Different Qtys)', width: null },
    { key: 'doYouRequireHardCopy', label: 'Require Hard Copy', width: null },
    { key: 'archaeologicalArea', label: 'Archaeological Area', width: null },
    { key: 'recreationalArea', label: 'Recreational Area', width: null },
    { key: 'waterways', label: 'Waterways', width: null },
    { key: 'powerOrPhoneLines', label: 'Power / Phone Lines', width: null },
    { key: 'railLines', label: 'Rail Lines', width: null },
    { key: 'nearbyDwellings', label: 'Nearby Dwellings', width: null },
    { key: 'otherPleaseDetail', label: 'Other (Detail)', width: null },
    { key: 'isPermitDocRequired', label: 'Permit Doc Required', width: null },
    { key: 'isSupplierDocRequired', label: 'Supplier Doc Required', width: null },
  ],
  notificationContact: [
    { key: 'growerContact', label: 'Grower Contact', width: null },
    { key: 'notificationSection', label: 'Notification Section', width: null },
  ],
  accountInfo: [
    { key: 'accountHolderName', label: 'Account Holder Name', width: null },
    { key: 'bankName', label: 'Bank Name', width: null },
    { key: 'bic', label: 'BIC', width: null },
    { key: 'iban', label: 'IBAN', width: null },
  ],
};
